import * as React from 'react'
// libs
import styled from 'styled-components'
// components
import { components } from 'react-select'
// types
import { MultiValueLabelProps } from 'components/FormElements/components/MultiValueLabel'
import { WrappedFieldInputProps } from 'redux-form/lib/Field'

const Wrapper = styled.div`
  &:hover {
    font-weight: 500;
  }
`

interface SelectProps {
  input: WrappedFieldInputProps
  onOptionClick: (...args: any) => void
}

const TagMultiValueLabel: React.FC<MultiValueLabelProps & { selectProps: SelectProps }> = (props) => {
  const { data, selectProps } = props

  const { value, onChange } = selectProps.input

  const onMouseDown = (event: React.MouseEvent) => event.stopPropagation()

  const onClick = () => selectProps.onOptionClick?.({ data, onChange, selectValue: value })

  return (
    <Wrapper onClick={onClick} onMouseDown={onMouseDown}>
      <components.MultiValueLabel {...props} />
    </Wrapper>
  )
}

export default TagMultiValueLabel
